import React from 'react';
import { useReactFlow } from 'reactflow';
import { useTheme } from '../../../contexts/ThemeContext';

interface ZoomControlsProps {
  layout?: 'compact' | 'full' | 'minimal';
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({ layout = 'full' }) => {
  const { darkMode } = useTheme();
  const { zoomIn, zoomOut, fitView, zoomTo } = useReactFlow();

  const buttonClass = `p-1 rounded transition-all duration-200 ${
    darkMode
      ? 'bg-green-800 hover:bg-green-700 text-white hover:shadow-green-500/30 hover:shadow-md'
      : 'bg-green-600 hover:bg-green-700 text-white hover:shadow-green-400/40 hover:shadow-sm'
  }`;

  if (layout === 'minimal') {
    return (
      <div className="flex items-center space-x-1">
        <button onClick={() => zoomIn()} className="p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">+</button>
        <button onClick={() => zoomOut()} className="p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">-</button>
        <button onClick={() => fitView({ padding: 0.2 })} className="p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded">⌂</button>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-0.5 bg-gray-100/50 dark:bg-gray-800/50 rounded-lg p-0.5">
      <button 
        onClick={() => zoomIn()} 
        className={`${buttonClass} w-6 h-6 flex items-center justify-center text-sm font-bold hover:scale-110`} 
        title="Zoom In"
      >
        +
      </button>
      <button 
        onClick={() => zoomOut()} 
        className={`${buttonClass} w-6 h-6 flex items-center justify-center text-sm font-bold hover:scale-110`} 
        title="Zoom Out"
      >
        −
      </button>
      <button 
        onClick={() => fitView({ padding: 0.2 })} 
        className={`${buttonClass} w-6 h-6 flex items-center justify-center text-xs hover:scale-110`} 
        title="Fit View"
      >
        ⌂
      </button>
      {layout === 'full' && (
        <button 
          onClick={() => zoomTo(1)} 
          className={`px-1.5 py-0.5 text-xs rounded font-medium hover:scale-105 transition-all duration-200 ${buttonClass}`}
        >
          100%
        </button>
      )}
    </div>
  );
};
